import { useCallback, useMemo, useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';

const useUnsavedChangesWarning = (
  message = 'Você não salvou as alterações, deseja descartar as alterações?',
) => {
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = () => message;

    if (isDirty) {
      window.addEventListener('beforeunload', handleBeforeUnload);

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }
  }, [isDirty, message]);

  const setPristine = useCallback(() => setIsDirty(false), []);
  const setDirty = useCallback(() => setIsDirty(true), []);

  const values = useMemo(() => {
    const routerPrompt = <Prompt when={isDirty} message={message} />;
    return {
      routerPrompt,
      setDirty,
      setPristine,
    };
  }, [isDirty, message, setDirty, setPristine]);

  return values;
};

export default useUnsavedChangesWarning;
